import React, { useCallback } from "react";
import { ReportCode } from "services/api/reports/types";
import { ReportContentProps } from "./types";
import ReportC02Consumption from "../ReportC02Consumption/ReportC02Consumption";

const ReportContent: React.FC<ReportContentProps> = (props) => {
  const { report } = props;

  const ReportResult = useCallback(() => {
    if (!report) {
      return null;
    }

    switch (report.id) {
      case ReportCode.ReportC02Consumption:
        return <ReportC02Consumption report={report} />;
      default:
        return null;
    }
  }, [report]);

  return (
    <>
      <div className="flex h-screen">
        <div className="grow ease-in-out duration-500 w-80 p-6 ">
          <ReportResult />
        </div>
      </div>
    </>
  );
};

export default ReportContent;
